import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from 'recharts';
import type { CategoryDatum } from '../reportData';
import { series, chrome, chartFont } from '../reportTheme';
import ChartTooltip from './ChartTooltip';

const axisTick = { fill: chrome.muted, fontSize: 12, fontFamily: chartFont };

interface CategoryBarChartProps {
  data: CategoryDatum[];
  unit?: string;
  max?: number;
  seriesName?: string;
}

const CategoryBarChart: React.FC<CategoryBarChartProps> = ({
  data,
  unit = '',
  max,
  seriesName = 'value',
}) => {
  const fmt = (v: number | string) => `${v}${unit}`;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 4, right: 40, left: 8, bottom: 0 }}
        barCategoryGap="28%"
      >
        <CartesianGrid stroke={chrome.grid} horizontal={false} />
        <XAxis
          type="number"
          domain={max ? [0, max] : undefined}
          tickFormatter={fmt}
          tick={axisTick}
          tickLine={false}
          axisLine={false}
          allowDecimals={false}
        />
        <YAxis
          type="category"
          dataKey="label"
          tick={axisTick}
          tickLine={false}
          axisLine={{ stroke: chrome.axis }}
          width={104}
        />
        <Tooltip
          content={<ChartTooltip valueFormatter={fmt} />}
          cursor={{ fill: 'rgba(45,120,219,0.06)' }}
        />
        <Bar dataKey="value" name={seriesName} fill={series.blue} radius={[0, 4, 4, 0]} maxBarSize={22}>
          <LabelList
            dataKey="value"
            position="right"
            formatter={fmt}
            style={{ fill: chrome.textSecondary, fontFamily: chartFont, fontSize: 12, fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CategoryBarChart;
